import { Union } from "../fable_modules/fable-library-js.4.24.0/Types.js";
import { union_type } from "../fable_modules/fable-library-js.4.24.0/Reflection.js";
import { createElement } from "react";
import React from "react";
import { reactApi } from "../fable_modules/Feliz.2.9.0/Interop.fs.js";
import { useEffectDisposableOnce } from "../fable_modules/Feliz.2.9.0/Internal.fs.js";
import { defaultOf } from "../fable_modules/fable-library-js.4.24.0/Util.js";
import { equals, createObj } from "../fable_modules/fable-library-js.4.24.0/Util.js";
import { Helpers_combineClasses } from "../fable_modules/Feliz.DaisyUI.5.0.0/DaisyUI.fs.js";
import { React_withKeyAuto_2B31D457 } from "../UI.js";
import { empty, singleton, append, delay, toList } from "../fable_modules/fable-library-js.4.24.0/Seq.js";
import { ofArray } from "../fable_modules/fable-library-js.4.24.0/List.js";

export class Dismiss extends Union {
    constructor(tag, fields) {
        super();
        this.tag = tag;
        this.fields = fields;
    }
    cases() {
        return ["Auto", "Manual"];
    }
}

export function Dismiss_$reflection() {
    return union_type("Shopfoo.Client.Components.Toast.Dismiss", [], Dismiss, () => [[], []]);
}

const Timeout = 3000;

export function Toast(toastInputProps) {
    let elems_2, elems_1;
    const children = toastInputProps.children;
    const onDismiss = toastInputProps.onDismiss;
    const dismiss = toastInputProps.dismiss;
    const alertProps = toastInputProps.alertProps;
    const key = toastInputProps.$key;
    const patternInput = reactApi.useState(true);
    const toggle = patternInput[1];
    useEffectDisposableOnce(() => {
        if (dismiss.tag === 1) {
            return {
                Dispose() {
                },
            };
        }
        else {
            const hidingTimeoutId = setTimeout(() => {
                toggle(false);
                onDismiss();
            }, ~~Timeout) | 0;
            return {
                Dispose() {
                    clearTimeout(hidingTimeoutId);
                },
            };
        }
    });
    if (!patternInput[0]) {
        return defaultOf();
    }
    else {
        return createElement("div", createObj(Helpers_combineClasses("toast", ofArray([["className", "toast-bottom"], ["className", "toast-end"], ["key", `${key}-toast`], (elems_2 = [React_withKeyAuto_2B31D457(createElement("div", createObj(ofArray([["key", `${key}-toast-container`], ["className", "relative"], (elems_1 = toList(delay(() => append(singleton(createElement("div", createObj(Helpers_combineClasses("alert", toList(delay(() => append(singleton(["key", `${key}-toast-alert`]), delay(() => append(alertProps, delay(() => append(equals(dismiss, new Dismiss(1, [])) ? singleton(["className", "pr-12"]) : empty(), delay(() => singleton(["children", reactApi.Children.toArray(Array.from(children))]))))))))))))), delay(() => (equals(dismiss, new Dismiss(1, [])) ? singleton(createElement("button", createObj(Helpers_combineClasses("btn", ofArray([["className", "btn-sm"], ["className", "btn-circle"], ["className", "btn-ghost"], ["className", "absolute right-2 top-2"], ["children", "✕"], ["onClick", (_arg_1) => {
            toggle(false);
            onDismiss();
        }]]))))) : empty()))))), ["children", reactApi.Children.toArray(Array.from(elems_1))])]))))], ["children", reactApi.Children.toArray(Array.from(elems_2))])]))));
    }
}

